export default __webpack_public_path__ + "82a06409e9621bb21591525cb0e83e14.png";